/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OnBehalfInChoice = typeof OnBehalfInChoice[keyof typeof OnBehalfInChoice];


export const OnBehalfInChoice = {
  granted: 'granted',
  declined: 'declined',
} as const;
